import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OptionButton } from 'components';
import './styles.css';

export default class OptionsField extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })),
    selected: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  }

  static defaultProps = {
    options: [],
    selected: null
  }

  render() {
    const { options, selected } = this.props;
    return (
      <div className="options">
        {
          options.map((option) => {
            const isSelected = selected && selected.value === option.value;
            return (
              <OptionButton
                key={option.value}
                isSelected={isSelected}
                onClick={() => this.props.onSelect(option)}
              >
                <div
                  className="type__option"
                >
                  {option.label}
                </div>
              </OptionButton>
            )
          })
        }
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/OptionsField/OptionsField.js